'use client'

import { ArrowLeftRight, Card, CardContent, CardHeader, CardTitle } from '@chain-zen/ui'

import type { IShipment } from '../../types/shipment'
import { BackhaulContent } from '../backhauls/backhaul-content'
import { BackhaulEmptyState } from '../backhauls/backhaul-empty-state'
import { BackhaulPostsSkeleton } from '../backhauls/backhaul-posts-skeleton'
import { LoadboardButton } from '../backhauls/loadboard-button'
import { useBackhaulPosts } from './use-backhaul-posts'

interface BackhaulPostsProps {
  itemsPerPage?: number
  postsView: 'card' | 'table'
  shipment: IShipment
}

export function BackhaulPosts({ itemsPerPage, shipment, postsView }: BackhaulPostsProps) {
  const { isLoading, loadsPageURL, posts, workspacename, enterpriseWorkspaceID } = useBackhaulPosts({
    itemsPerPage: itemsPerPage || 4,
    shipment
  })

  // Loading state
  if (isLoading) {
    return <BackhaulPostsSkeleton postsView={postsView} />
  }

  // Empty state
  if (posts.length === 0) {
    return <BackhaulEmptyState loadsPageURL={loadsPageURL} />
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <ArrowLeftRight className="h-4 w-4 text-primary" />
          Backhauls
        </CardTitle>
      </CardHeader>
      <CardContent>
        <BackhaulContent
          postsView={postsView}
          posts={posts}
          workspacename={workspacename}
          enterpriseWorkspaceID={enterpriseWorkspaceID}
        />
        <LoadboardButton loadsPageURL={loadsPageURL} />
      </CardContent>
    </Card>
  )
}
